import { useQuery } from '@tanstack/react-query';

import { SECOND_IN_MS } from '@/lib/constants/time';
import { getIntegrationConflicts } from '@/modules/common/api/integration-conflicts.api';

export const INTEGRATION_CONFLICTS_QUERY_KEY = ['integrationConflicts'];

// Same cadence as the integration status card
const POLLING_INTERVAL = 30 * SECOND_IN_MS;

interface UseIntegrationConflictsOptions {
  enabled?: boolean;
}

/**
 * Polls the organization's data conflicts summary for users who can see conflicts
 * but can't resolve them.
 */
export const useIntegrationConflicts = ({
  enabled = true,
}: UseIntegrationConflictsOptions = {}) => {
  return useQuery({
    queryKey: INTEGRATION_CONFLICTS_QUERY_KEY,
    queryFn: getIntegrationConflicts,
    enabled,
    refetchInterval: enabled ? POLLING_INTERVAL : false,
    staleTime: 10 * SECOND_IN_MS,
  });
};
